<template>
  <div class="home-page">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <div v-else-if="homeData">
      <HomePageFirstSection v-if="defer(2)"
                            :fullData="homeData"
                            :title="$get(homeData, 'slider[0].title')"/>

      <HomePageHotVacancies v-if="defer(6)"
                            :vacancies="homeData.hot_vacancies"/>

      <HomePageCategories v-if="defer(8)"
                          :items="homeData.home_categories"/>

      <HomePageHowItWork v-if="defer(10)"
                         :items="homeData.how_it_works"/>

      <HomePageReviews v-if="defer(12)"
                       :reviews="homeData.reviews.data"/>

      <HomePageVideo v-if="defer(16)"
                     :video="homeData.video_block"/>

      <HomePageWorkCountries v-if="defer(14)"
                             :countries="homeData.home_countries"/>

      <ServiceCarousel v-if="defer(16)"
                       id="service-carousel"
                       :slides="homeData.service_slider"
                       class="service-carousel"/>

      <AddressSection v-if="defer(18)"
                      :title="$tHome('Addresses')"
                      :addresses="homeData.address_block"/>

      <HomePageText v-if="defer(20)"
                    :body="homeData.home_meta.seo_text"/>
    </div>

  </div>
</template>

<script>
  import {http} from '@/axios'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import defer from '@/mixins/defer'
  import HomePageFirstSection from '@/components/homePage/HomePageFirstSection'
  import HomePageHotVacancies from '@/components/homePage/HomePageHotVacancies'
  import HomePageCategories from '@/components/homePage/HomePageCategories'
  import HomePageHowItWork from '@/components/homePage/HomePageHowItWork'
  import HomePageReviews from '@/components/homePage/HomePageReviews'
  import HomePageWorkCountries from '@/components/homePage/HomePageWorkCountries'
  import HomePageVideo from '@/components/homePage/HomePageVideo'
  import HomePageText from '@/components/homePage/HomePageText'
  import ServiceCarousel from '@/components/ServiceCarousel'
  import AddressSection from '@/components/AddressSection'

  import {
    openModalsWeFindYouWork,
    stopOpenModalsWeFindYouWork
  } from '@/services/modalsAutoShow'

  export default {
    mixins: [globalMetaMixin, defer(22)],
    components: {
      HomePageFirstSection,
      HomePageHotVacancies,
      HomePageCategories,
      HomePageHowItWork,
      HomePageReviews,
      HomePageWorkCountries,
      HomePageVideo,
      HomePageText,
      ServiceCarousel,
      AddressSection,
    },
    data() {
      return {
        pending: false,
        homeData: null,

        runDefferAutomatically: false,
        checkScrollByMountedCounter: {
          all: 3,
          current: 0
        }
      }
    },
    computed: {},
    methods: {
      load() {
        this.pending = true

        return http.get('/api/home-v2').then(({data}) => {
          this.homeData = data.data

          const meta = data.data.home_meta

          if (meta.meta_title) {
            this.setMetaTitleMixin(meta.meta_title)
          }

          if (meta.meta_description) {
            this.setMetaDescriptionMixin(meta.meta_description)
          }

          if (meta.meta_keywords) {
            this.setMetaKeywords(meta.meta_keywords)
          }

          this.setOpenGraph({
            title: meta.meta_title && this.setMetaTitleMixin(meta.meta_title),
            description: meta.meta_description && this.setMetaDescriptionMixin(meta.meta_description),
          })

          this.runDisplayPriority()
        }).finally(() => {
          this.pending = false
        })
      },
      checkScrollByMounted() {
        this.checkScrollByMountedCounter.current++
        const counter = this.checkScrollByMountedCounter

        if (counter.all === counter.current) {
          this.scrollToHash()
        }
      },
      scrollToHash() {
        let hash = this.$route.hash
        if (!hash) return

        setTimeout(() => {
          this.$scrollTo(hash)
        }, 50)
      }
    },
    created() {
      this.load()
    },
    mounted() {
      openModalsWeFindYouWork(10000, 'home')
    },
    beforeDestroy() {
      stopOpenModalsWeFindYouWork()
    },
    watch: {}
  }
</script>

<style lang="less">

</style>
